import { Link } from "wouter";
import { Mail, Phone, MapPin, Twitter, Linkedin, Instagram, Youtube } from "lucide-react";

const footerLinks = {
  product: [
    { label: "المميزات", href: "/features" },
    { label: "الأسعار", href: "/pricing" },
    { label: "ابدأ متجراً", href: "/register" },
    { label: "المدونة", href: "/blog" },
  ],
  company: [
    { label: "من نحن", href: "/about" },
    { label: "تواصل معنا", href: "/contact" },
    { label: "التسويق بالعمولة", href: "/partners" },
    { label: "احجز اجتماع", href: "/book-meeting" },
  ],
  support: [
    { label: "مركز المساعدة", href: "/faq" },
    { label: "تواصل معنا", href: "/contact" },
    { label: "الأسئلة الشائعة", href: "/faq" },
    { label: "الاستخدام المقبول", href: "/acceptable-use" },
  ],
  legal: [
    { label: "سياسة الخصوصية", href: "/privacy" },
    { label: "شروط الاستخدام", href: "/terms" },
    { label: "اتفاقية التاجر", href: "/merchant-agreement" },
    { label: "حذف البيانات", href: "/data-deletion" },
  ],
};

export default function MarketingFooter() {
  return (
    <footer className="footer-dark" dir="rtl">
      <div className="container py-14">
        <div className="grid grid-cols-2 md:grid-cols-6 gap-8 lg:gap-10">
          <div className="col-span-2">
            <Link href="/" className="inline-flex items-center gap-2 mb-5 cursor-pointer">
                <img src="/nexus-cart-icon.png" alt="نكسس كارت" className="h-8 w-8 object-contain" onError={(e) => { (e.currentTarget as HTMLImageElement).style.display = "none"; }} />
                <span className="font-black text-lg text-white" style={{ fontFamily: "'Cairo', sans-serif" }}>نكسس كارت</span>
              </Link>
            <p className="text-slate-400 text-sm leading-relaxed mb-6 max-w-xs" style={{ fontFamily: "'Tajawal', sans-serif" }}>
              منصة التجارة الإلكترونية العربية الأولى. أنشئ متجرك الاحترافي وابدأ البيع اليوم بأكثر من 150 ميزة جاهزة.
            </p>
            <div className="space-y-2.5">
              <a href="mailto:info@nexuscart.co" className="flex items-center gap-2.5 text-sm text-slate-400 hover:text-white transition-colors" style={{ fontFamily: "'Tajawal', sans-serif" }}>
                <Mail className="w-4 h-4 flex-shrink-0" /> info@nexuscart.co
              </a>
              <a href="tel:+966562844445" className="flex items-center gap-2.5 text-sm text-slate-400 hover:text-white transition-colors" style={{ fontFamily: "'Tajawal', sans-serif" }}>
                <Phone className="w-4 h-4 flex-shrink-0" /> +966 56 284 4445
              </a>
              <div className="flex items-center gap-2.5 text-sm text-slate-400" style={{ fontFamily: "'Tajawal', sans-serif" }}>
                <MapPin className="w-4 h-4 flex-shrink-0" /> الخبر، المملكة العربية السعودية
              </div>
            </div>
          </div>

          {([
            ["المنتج", footerLinks.product],
            ["الشركة", footerLinks.company],
            ["الدعم", footerLinks.support],
            ["القانونية", footerLinks.legal],
          ] as const).map(([title, list]) => (
            <div key={title}>
              <h4 className="text-white font-bold text-sm mb-4" style={{ fontFamily: "'Cairo', sans-serif" }}>{title}</h4>
              <ul className="space-y-2.5">
                {list.map((l) => (
                  <li key={l.label}>
                    <Link href={l.href} className="text-sm text-slate-400 hover:text-white transition-colors" style={{ fontFamily: "'Tajawal', sans-serif" }}>{l.label}</Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      <div style={{ borderTop: "1px solid rgba(255,255,255,0.08)" }}>
        <div className="container py-5 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-slate-500 text-sm" style={{ fontFamily: "'Tajawal', sans-serif" }}>
            © {new Date().getFullYear()} نكسس كارت — جميع الحقوق محفوظة
          </p>
          <div className="flex items-center gap-2">
            {[
              { icon: Twitter, label: "تويتر" },
              { icon: Instagram, label: "إنستغرام" },
              { icon: Linkedin, label: "لينكدإن" },
              { icon: Youtube, label: "يوتيوب" },
            ].map(({ icon: Icon, label }) => (
              <a key={label} href="#" aria-label={label} className="w-8 h-8 rounded-lg flex items-center justify-center text-slate-500 hover:text-white transition-colors" style={{ background: "rgba(255,255,255,0.06)" }}>
                <Icon className="w-4 h-4" />
              </a>
            ))}
          </div>
          <div className="flex items-center gap-1.5">
            <div className="w-2 h-2 rounded-full bg-emerald-400" />
            <span className="text-slate-500 text-xs" style={{ fontFamily: "'Tajawal', sans-serif" }}>جميع الأنظمة تعمل</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
